import React from "react";

function TitreHeader() {
    return(
        <div className="titreHeader" >
            <p style={{ fontSize: '20px' }}>Portfolio de BRUNET Nicolas - Développeur Web</p>
        </div>
    );
}

export default TitreHeader;